export const USER_ROLES = {
    ADMIN: 'admin',
    TEACHER: 'teacher',
    CUSTOMER: 'customer',
    MANAGER: 'manager',
    DISTRICT_ADMIN: 'district_admin',
} as const;
export const USER_STATUSES = {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
} as const;

export const USER_ROLE_OPTIONS = (t: Function) => Object.entries(USER_ROLES).map(([_, value]) => ({ label: t(`users.role.${value}`), value })) as TDropdownOption[];
export const USER_STATUS_OPTIONS = (t: Function) => Object.entries(USER_STATUSES).map(([_, value]) => ({ label: t(`users.status.${value}`), value })) as TDropdownOption[];
